import {ApiBase} from "@/api/common";
import config from "@/config";

const NO_UPLOAD_FIELDS = [
    'icon_link',
];

export default class CourseSkill extends ApiBase<CourseSkill> {
    public static readonly SLUG: string = 'course-skill';
    private static readonly URL_BASE: string = config.API_ROOT + '/course-skill/';

    public id?: number = undefined;
    public parent_module?: number = undefined;
    public icon?: number = undefined;
    public icon_link?: string = undefined;
    public icon_file?: File|null = undefined;
    public name?: string = undefined;
    public state?: string = 'created';

    public constructor() {
        super({
            urlBase: CourseSkill.URL_BASE,
            filteredFields: NO_UPLOAD_FIELDS,
        });
    }

    public assign(response: any): CourseSkill {
        super.assign(response);
        return this;
    }

    public async save(): Promise<number> {
        return super.save();
    }

    public async delete(): Promise<void> {
        return super.delete();
    }

}